// extracted by mini-css-extract-plugin
export default {"typeContainer":"Color_typeContainer__JFcVP","item":"Color_item__lEaSS","item-selected":"Color_item-selected__jlRl4"};